<template>
  <v-main>
    <navigation v-if="!liffUser"/>
    <guide-tour config-key="reschedule"/>
    <v-tabs :value="tab" @change="handleTabChange" right>
      <v-tab>未處理</v-tab>
      <v-tab>已處理</v-tab>
      <v-tab v-if="clinicUser">{{ $t('RescheduleSettings.title') }}</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab" touchless>
      <v-tab-item>
        <reschedule-data-table ref="unConcat"/>
      </v-tab-item>
      <v-tab-item>
        <reschedule-data-table ref="concat" kind="2"/>
      </v-tab-item>
      <v-tab-item v-if="clinicUser">
        <reschedule-settings-page ref="settingsPage"/>
      </v-tab-item>
    </v-tabs-items>
  </v-main>
</template>

<script>
import Navigation from "../components/Navigation";
import { mapGetters } from "vuex";
import RescheduleDataTable from '../components/Reschedule/RescheduleDataTable';
import GuideTour from "../components/utils/GuideTour.vue";
import RescheduleSettingsPage from "../components/Reschedule/RescheduleSettingsPage.vue";

export default {
  name: "Reschedule",

  components: {GuideTour, RescheduleDataTable, Navigation, RescheduleSettingsPage},

  data() {
    return {
      tab: null,
      previousTab: null
    }
  },

  computed: {
    ...mapGetters([
      'liffUser',
      'clinicUser'
    ]),
    isAnyEditing() {
      const settingsPage = this.$refs.settingsPage
      if (!settingsPage) return false
      // 檢查改約選項編輯
      const isOptionsEditing = settingsPage.isOptionsEditing || false
      // 檢查改約限制設定編輯
      const isSettingEditing = settingsPage.$refs.settingRef?.isEditing || false
      return isOptionsEditing || isSettingEditing
    }
  },

  async beforeRouteLeave(to, from, next) {
    if (this.isAnyEditing) {
      const answer = await this.$notify.confirm(this.$t('RescheduleSettings.unsavedChangesWarning'))
      if (answer) {
        next()
      } else {
        next(false)
      }
    } else {
      next()
    }
  },

  methods: {
    async handleTabChange(newVal) {
      const oldVal = this.tab
      const settingsTabIndex = this.clinicUser ? 2 : -1

      // 檢查是否從設定頁切換出去且正在編輯中
      if (oldVal === settingsTabIndex && this.isAnyEditing) {
        const answer = await this.$notify.confirm(this.$t('RescheduleSettings.unsavedChangesWarning'))
        if (!answer) {
          return // 不切換
        }
      }

      // 允許切換
      this.tab = newVal

      // 切換後重新載入資料
      if (newVal === 0 && this.$refs.unConcat) {
        this.$refs.unConcat.getRescheduleList()
      } else if (newVal === 1 && this.$refs.concat) {
        this.$refs.concat.getRescheduleList()
      }
    }
  }
}
</script>

<style scoped>

</style>
